import FormToolbar from '../../../../adminPanel/screens/Actions/FormToolbar/FormToolbar'
import React from 'react'
import PostLicenseButton from './PostLicenseButton'

export default ({ ...props }) => {
  return (
    <FormToolbar withSave={false}>
      <PostLicenseButton />
    </FormToolbar>
  )
}
